<template>
  <div :class="classes">
    <div v-if="!$attrs.readonly && !editMode" class="note-field__edit-btn">
      <m4-button @click="toggle" tag="a" size="sm" variant="primary-text">
        <m4-icon icon="edit-alt"></m4-icon>
        {{ computedBtnTitle }}
      </m4-button>
    </div>
    <m4-preview v-if="openAlertBox" title=" " :with-icon="false">
      <m4-alert bottom-arrow :variant="alertVariant">
        <span v-html="linedNewValue"></span>
      </m4-alert>
    </m4-preview>
    <m4-form-field
      v-bind="$attrs"
      type="textarea"
      @update:modelValue="onInput"
      @blur="ajaxSave()"
      :value="value"
    ></m4-form-field>
  </div>
</template>

<script>
import valueProp from "../../../../frontend/utils/valueProp.js";

export default {
  name: "M4NoteField",
  mixins: [valueProp],
  data() {
    return {
      isOpened: this.opened,
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    modelValue: {
      type: [String, Number]
    },
    opened: Boolean,
    alertVariant: {
      type: String,
      default() {
        return "info";
      }
    },
    fullWidth: Boolean,
    btnTitle: {
      type: String,
      default() {
        return "Edit note";
      }
    },
    btnCloseTitle: {
      type: String,
      default() {
        return "Close note";
      }
    },
    btnSaveAndCloseTitle: {
      type: String,
      default() {
        return "Save and close note";
      }
    },
    autoSaveUrl: String,
    editMode: Boolean
  },
  computed: {
    computedBtnTitle() {
      if (this.autoSaveUrl) {
        if (this.isOpened) {
          return this.btnSaveAndCloseTitle;
        } else {
          return this.btnTitle;
        }
      }
      return this.isOpened ? this.btnCloseTitle : this.btnTitle;
    },
    classes() {
      let classes = ["note-field"];
      if (this.isOpened) {
        classes.push("form-field--opened");
      }
      if (this.fullWidth) {
        classes.push("form-field--full-width");
      }
      return classes;
    },
    linedNewValue() {
      return this.newValue ? this.newValue.replaceAll("\n", "<br>") : null;
    },
    openAlertBox() {
      return this.newValue && !this.isOpened;
    }
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
    },
    onInput(val) {
      if (typeof val === "string") {
        this.newValue = val;
      }
    },
    ajaxSave() {
      if (this.autoSaveUrl) {
        window
          .axios({
            method: "post",
            url: this.autoSaveUrl,
            data: { text: this.newValue }
          })
          .then(() => {
            //
          })
          .catch((Error) => {
            if (Error.response != undefined && Error.response.data != undefined) {
              alert(Error.response.data.errors[0].details);
            } else {
              alert(Error);
            }
          });
      }
    }
  },
  watch: {
    opened(val) {
      this.isOpened = val;
    }
  }
};
</script>
